import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function BonosSection() {
  const bonos = [{
    num: '1',
    title: 'Kit de Arranque Rápido',
    desc: 'Setup completo en 60 min',
    value: '$15.000'
  }, {
    num: '2',
    title: '50 Plantillas de Mail Profesional',
    desc: 'Copiar y pegar',
    value: '$12.000'
  }, {
    num: '3',
    title: 'Checklist Maestra de Excel',
    desc: 'Nunca más te bloqueás',
    value: '$10.000'
  }, {
    num: '4',
    title: 'Agenda Perfecta en 7 Días',
    desc: 'Sistema completo',
    value: '$12.000'
  }, {
    num: '5',
    title: 'Guía Express de Imagen Profesional desde Casa',
    desc: '',
    value: '$10.000'
  }, {
    num: '6',
    title: 'Plan de Confianza Digital para Mujeres 40+',
    desc: '',
    value: '$10.000'
  }];
  return <section className="bg-night py-12" data-id="element-25">
      <div className="max-w-5xl mx-auto px-6" data-id="element-26">
        <div className="text-center mb-8" data-id="element-27">
          <h3 className="text-3xl md:text-4xl font-bold text-white mb-4 flex items-center justify-center gap-3" data-id="element-28">
            <Gift className="w-8 h-8 text-gold-accent" data-id="element-29" />
            LOS 6 BONOS — SIEMPRE INCLUIDOS
          </h3>
        </div>

        <div className="grid md:grid-cols-2 gap-4 mb-8" data-id="element-30">
          {bonos.map((bono, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: idx * 0.1
        }} className="glass rounded-xl p-5 flex items-center gap-4 hover:border-gold-accent/40 transition-colors" data-id="element-31">
              <div className="w-12 h-12 bg-gold-accent/15 border border-gold-accent/30 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-32">
                <Gift className="w-6 h-6 text-gold-accent" data-id="element-33" />
              </div>
              <div className="flex-1" data-id="element-34">
                <h4 className="font-bold text-white leading-tight mb-1" data-id="element-35">
                  Bono {bono.num}: {bono.title}
                </h4>
                {bono.desc && <p className="text-sm text-textLight" data-id="element-36">{bono.desc}</p>}
              </div>
              <div className="text-right flex-shrink-0" data-id="element-37">
                <p className="text-sm text-textLight/70 line-through decoration-red-400" data-id="element-38">
                  {bono.value}
                </p>
                <p className="font-bold text-gold-accent" data-id="element-39">GRATIS</p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="glass rounded-2xl p-8 text-center border-2 border-gold-accent/60 shadow-[0_0_40px_rgba(224,178,76,0.15)] max-w-2xl mx-auto" data-id="element-40">
          <p className="text-xl text-textLight mb-2" data-id="element-41">Valor total bonos</p>
          <div className="flex items-center justify-center gap-4 text-3xl md:text-4xl font-bold" data-id="element-42">
            <span className="text-textLight/60 line-through decoration-red-400" data-id="element-43">
              $69.000
            </span>
            <span className="text-gold-accent" data-id="element-44">→ GRATIS</span>
          </div>
          <p className="text-lg font-medium text-white mt-2" data-id="element-45">
            con tu Colección
          </p>
        </motion.div>
      </div>
    </section>;
}